module.exports = __webpack_public_path__ + "img/check.c920028f.svg";